
<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('child_admission_management.approval_management') }}</h4>
        </template>
        <template v-slot:body>
            <b-row>
                <b-col lg="4" sm="12" md="4">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="fiscal_year_id"
                        >
                        <template v-slot:label>
                        {{$t('globalTrans.fiscal_year')}}
                        </template>
                        <b-form-select
                        plain
                        v-model="search.fiscal_year_id"
                        id="fiscal_year_id"
                        :options="fiscalYearList"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="4" sm="12">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="organiation_id"
                        >
                        <template v-slot:label>
                            {{$t('globalTrans.organization')}}
                        </template>
                        <b-form-select
                        plain
                        v-model="search.org_id"
                        :options="orgList"
                        id="organiation_id"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="4" sm="12">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="office_type_id"
                        >
                        <template v-slot:label>
                            {{$t('child_configuration.institute_type')}}
                        </template>
                        <b-form-select
                        plain
                        v-model="search.office_type_id"
                        :options="officeTypeList"
                        id="office_type_id"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="4" sm="12">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="office_id"
                        >
                        <template v-slot:label>
                            {{$t('child_configuration.institute_name')}}
                        </template>
                        <b-form-select
                        plain
                        v-model="search.office_id"
                        :options="officeList"
                        id="office_id"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="4" sm="12" md="4">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="registration_id"
                        >
                        <template v-slot:label>
                        {{$t('child_admission_management.registration_id')}}
                        </template>
                        <b-form-input
                        v-model="search.registration_id"
                        id="registration_id"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                </b-col>
            </b-row>
        </template>
    </iq-card>
    <!-- /Search Form -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('child_admission_management.approval') + ' ' + $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(view)="data">
                      <!-- <b-button class="mr-2" title="View checklist" v-b-modal.modal-detail variant=" iq-bg-info border-info" size="sm" @click="details(data.item)"><i class="ri-eye-line m-0 "></i></b-button> -->
                      <a href="javascript:" class="btn_table_action btn_green" title="View checklist" v-b-modal.modal-detail @click="details(data.item)"><i class="fas fa-eye"></i></a>
                    </template>
                    <template v-slot:cell(resident_approve)="data">
                      <span v-if="data.item.meeting_type == 1">
                          <span class="badge badge-success" v-if="data.item.resident_approve == 1">
                              {{ $t('globalTrans.approved') }}
                          </span>
                          <span v-else-if="data.item.resident_approve == 2" class="badge badge-danger">
                            {{ $t('globalTrans.rejected') }}
                          </span>
                          <span v-else class="badge badge-danger">{{ $t('globalTrans.pending') }}</span>
                      </span>
                      <span v-else>
                          <span v-if="data.item.meeting_type == 2">
                            <span class="badge badge-success" v-if="data.item.child_approve == 1">
                                {{ $t('globalTrans.approved') }}
                            </span>
                            <span v-else-if="data.item.child_approve == 2" class="badge badge-danger">
                              {{ $t('globalTrans.rejected') }}
                            </span>
                            <span v-else class="badge badge-danger">{{ $t('globalTrans.pending') }}</span>
                          </span>
                      </span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <span v-if="data.item.resident_approve == 0 && data.item.meeting_type == 1">
                        <b-button variant=" iq-bg-success mr-1 mb-1 border-danger" size="sm" v-b-modal.modal-2 @click="addComment(data.item, 1)">
                          {{ $t('globalTrans.approve') }}
                        </b-button>
                        <b-button variant=" iq-bg-success mr-1 mb-1 border-danger" size="sm" v-b-modal.modal-2 @click="addComment(data.item, 2)">
                          {{ $t('globalTrans.reject') }}
                        </b-button>
                      </span>
                      <span v-else>
                          <span v-if="data.item.child_approve == 0 && data.item.meeting_type == 2">
                            <b-button variant=" iq-bg-success mr-1 mb-1 border-danger" size="sm" v-b-modal.modal-2 @click="addComment(data.item, 1)">
                              {{ $t('globalTrans.approve') }}
                            </b-button>
                            <b-button variant=" iq-bg-success mr-1 mb-1 border-danger" size="sm" v-b-modal.modal-2 @click="addComment(data.item, 2)">
                              {{ $t('globalTrans.reject') }}
                            </b-button>
                          </span>
                          <span v-else>N/A</span>
                      </span>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
     <b-modal id="modal-detail" size="lg" :title="detailTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :checklist="checklist" :id="editItemId" :key="editItemId" />
    </b-modal>
    <b-modal id="modal-2" size="lg" :title="approveDeny.approveStatus === 1 ? $t('globalTrans.approve') + ' ' + $t('child_admission_management.comments') : $t('globalTrans.reject') + ' ' + $t('child_admission_management.comments')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <b-container fluid>
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                <template>
                    <b-row>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-form-group
                                class="row"
                                label-cols-sm="3"
                                :label="$t('child_admission_management.comments_en')"
                                label-for="comments"
                            >
                            <b-form-input
                                id="comments"
                                v-model="approveDeny.comment"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-form-group
                                class="row"
                                label-cols-sm="3"
                                :label="$t('child_admission_management.comments_bn')"
                                label-for="comments"
                            >
                            <b-form-input
                                id="comments"
                                v-model="approveDeny.comment_bn"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
          </b-col>
        </b-row>
        <div class="row">
          <div class="col-sm-3"></div>
          <div class="col text-right">
            <b-button v-if="approveDeny.approveStatus === 1" @click="approveOrDenyStatus()" variant="primary" class="mr-2">{{ this.$t('globalTrans.approve') }}</b-button>
            <b-button v-else @click="approveOrDenyStatus()" variant="primary" class="mr-2">{{ this.$t('globalTrans.reject') }}</b-button>
             &nbsp;
            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.cancel') }}</b-button>
          </div>
        </div>
      </b-container>
    </b-modal>
  </b-container>
</template>
<script>
// import Form from './Form'
import DetailModal from './DetailModal'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { approvalManagementListApi, approveOrRejectApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'

export default {
  mixins: [RouteBasedList],
  components: {
    DetailModal
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        registration_id: ''
      },
      approveDeny: {
        registration_id: '',
        comment: '',
        comment_bn: '',
        approveStatus: 0,
        meeting_type: 0
      },
      checklist: {},
      editItemId: 0,
      officeTypeList: [],
      officeList: [],
      rows: []
    }
  },
  computed: {
    fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    detailTitle () {
        return this.$t('rehabilitation_management.e_checklist') + ' ' + this.$t('globalTrans.details')
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('child_admission_management.institute_name'), class: 'text-center' },
          { label: this.$t('rehabilitation_management.registration_id'), class: 'text-center' },
          { label: this.$t('rehabilitation_management.contact_no'), class: 'text-center' },
          { label: this.$t('rehabilitation_management.e_checklist'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'institute_name_bn' },
          { key: 'registration_id' },
          { key: 'contact_no' },
          { key: 'view' },
          { key: 'resident_approve' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'institute_name' },
          { key: 'registration_id' },
          { key: 'contact_no' },
          { key: 'view' },
          { key: 'resident_approve' },
          { key: 'action' }
        ]
      }
      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
      })
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
       this.getOfficeTypeList()
    },
    'search.office_type_id': function (newVal, oldVal) {
       this.getOfficeList()
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.org_id) {
                this.getOfficeTypeList()
            }
            if (this.search.office_type_id) {
                this.getOfficeList()
            }
        }
    }
  },
  created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
    this.loadData()
  },
  methods: {
    details (item) {
      this.editItemId = item.id
    },
    addComment (item, value) {
      this.approveDeny.registration_id = item.registration_id
      this.approveDeny.approveStatus = value
      this.approveDeny.meeting_type = item.meeting_type
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      RestApi.getData(childServiceBaseUrl, approvalManagementListApi, params).then(response => {
        if (response.success) {
            this.checklist = response.checklist
            this.$store.dispatch('setList', this.getRelationalData(response.data.data))
            this.paginationData(response.data)
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
      let tmpFiscalYear = {}
      let tmpInstitute = {}
      const listData = data.map(item => {
          tmpFiscalYear = this.$store.state.commonObj.fiscalYearList.find(fiscal => fiscal.value === item.fiscal_year_id && fiscal.status === 0)
          tmpInstitute = this.$store.state.commonObj.officeList.find(office => office.value === item.office_id && office.status === 0)
          const admissionData = {
              fiscal_year: tmpFiscalYear !== undefined ? tmpFiscalYear.text_en : '',
              fiscal_year_bn: tmpFiscalYear !== undefined ? tmpFiscalYear.text_bn : '',
              institute_name: tmpInstitute !== undefined ? tmpInstitute.text_en : '',
              institute_name_bn: tmpInstitute !== undefined ? tmpInstitute.text_bn : ''
          }
          return Object.assign({}, item, admissionData)
      })
      return listData
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value)).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    approveOrDenyStatus () {
        window.vm.$swal({
            title: this.approveDeny.approveStatus === 1 ? window.vm.$t('globalTrans.approveMsg') : window.vm.$t('globalTrans.rejectMsg'),
            showCancelButton: true,
            confirmButtonText: window.vm.$t('globalTrans.yes'),
            cancelButtonText: window.vm.$t('globalTrans.no'),
            focusConfirm: false
        }).then((result) => {
            if (result.isConfirmed) {
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                const loadingState = { loading: false, listReload: true }
                if (this.approveDeny.registration_id) {
                    RestApi.postData(childServiceBaseUrl, approveOrRejectApi, this.approveDeny).then(response => {
                    this.$store.dispatch('mutateCommonProperties', loadingState)
                        if (response.success) {
                            this.$toast.success({
                                title: this.$t('globalTrans.success'),
                                message: this.$t('globalTrans.update_msg'),
                                color: '#D6E09B'
                            })
                            this.$bvModal.hide('modal-2')
                        } else {
                            this.$refs.form.setErrors(response.errors)
                        }
                    })
                }
            }
        })
    }
  }
}
</script>
